// __private-exports
/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { TIMELINE_CHUNK_WIDTH_PX, TIMESCALE_MAPPING } from '../constants';
import type { GanttTimescale } from '../types';

export function getMsPerPx(timescale: GanttTimescale) {
  return TIMESCALE_MAPPING[timescale] / TIMELINE_CHUNK_WIDTH_PX;
}

/** @throws {RangeError} If endTimeMs < startTimeMs. */
export function getTotalTimelineMs(startTimeMs: number, endTimeMs: number) {
  if (endTimeMs < startTimeMs) {
    throw new RangeError(
      `endTimeMs (${endTimeMs}) must be >= startTimeMs (${startTimeMs})`,
    );
  }

  return endTimeMs - startTimeMs;
}

export function getTotalTimelineWidth(
  totalTimelineMs: number,
  msPerPx: number,
) {
  return totalTimelineMs / msPerPx;
}

export function getMsRepresentedInViewableRegion(
  viewableRegionWidth: number,
  msPerPx: number,
) {
  return viewableRegionWidth * msPerPx;
}
